import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {IconButton} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {apiCall} from "../../helpers/MainHelper";
import Swal from "sweetalert2";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";

class StockCategoriesTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
    }

    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleDelete = async (categoryId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(
                    <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
                );

                try {
                    const response = await apiCall('business/stock/category/delete/'+categoryId,'delete');
                    await this.triggerFetch();
                    return {success: true, message: response.message || 'Kategori başarıyla silindi.'};
                } catch (error) {
                    let errorMessage = 'Silme işlemi başarısız oldu.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                    return {success: false, message: errorMessage};
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed && result.value) {
            if (result.value.success) {
                Swal.fire('Silindi!', result.value.message, 'success');
            } else {
                Swal.fire('Hata!', result.value.message, 'error');
            }
        }
    }

    handleCategoryDetail = (categoryId) => {
        this.props.history.push(`/stock/category-detail/${categoryId}`);
    }

    render() {
        const {userPermissions} = this.props;
        const userHasViewPermission = userPermissions.includes('stock.view');
        const userHasDeletePermission = userPermissions.includes('stock.delete');

        const columns = [
            {
                name:'Kategori Adı',
                selector: row => row.name,
                sortable:true,
                grow: 2,
                wrap: true,
                cell: row => (
                    <div style={{fontWeight: '600', color: '#212529', padding: '12px 8px'}}>
                        {row.name}
                    </div>
                )
            },
            {
                name:'Açıklama',
                selector:row => row.description || '-',
                sortable:true,
                grow: 3,
                wrap: true,
                style: {
                    padding: '12px 8px'
                }
            },
            {
                name:'Alt Kategori Sayısı',
                selector:row => row.children ? row.children.length : 0,
                sortable:true,
                center: true,
                minWidth: '160px',
                maxWidth: '180px',
                cell: row => (
                    <div style={{
                        fontWeight: '600',
                        color: row.children && row.children.length > 0 ? '#17a2b8' : '#6c757d',
                        fontSize: '15px',
                        padding: '12px 8px'
                    }}>
                        {row.children ? row.children.length : 0} adet
                    </div>
                )
            },
            {
                name: 'İşlem',
                button: true,
                minWidth: '140px',
                maxWidth: '160px',
                center: true,
                cell: row => (
                    <div style={{display: 'flex', gap: '6px', justifyContent: 'center', padding: '8px'}}>

                        {userHasDeletePermission && (
                            <IconButton 
                                className="btn btn-outline-danger"
                                onClick={() => this.handleDelete(row.id)}
                                style={{padding: '8px 14px'}}>
                                <i className="icon-trash" style={{fontSize: '16px'}}></i>
                            </IconButton>
                        )}
                    </div>
                ),
            },
        ];

        return (
            <DataTable
                ref={this.tableRef}
                columns={columns}
                onRowClicked={userHasViewPermission ? row => this.handleCategoryDetail(row.id) : undefined}
                dataEndpoint="business/stock/category/all"
                extraQueryParams={{ parent_only: true }}
            />
        );
    }
}

export default withPermissions(withRouter(StockCategoriesTable));
